import { axiosConToken } from "../../helpers/axios";

import {
  messageLoading,
  messageSuccessLoading,
  validaMessagesErrors,
} from "../../helpers/messageConfig";
import { typesPedidoVenta as types } from "../../types";
import { PATH_VENTAS } from "../../constants/routes";

const key = "msgpedidosventas";

export const pedidosventasStartLoad = ({
  fechaemision_after = null,
  fechaemision_before = null,
  search = null,
  page = 1,
  page_size = 10,
}) => {
  return async (dispatch) => {
    dispatch(pedidoventaStatusLoading());
    try {
      const resp = await axiosConToken.get(`${PATH_VENTAS.pedidoventa}`, {
        params: {
          fechaemision_after,
          fechaemision_before,
          search,
          page,
          page_size,
        },
      });
      const data = resp.data;
      dispatch(pedidoventaLoaded(data));
    } catch (error) {
      validaMessagesErrors(error, key);
    } finally {
      dispatch(pedidoventaStatusLoading(false));
    }
  };
};
export const pedidoventaStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(`${PATH_VENTAS.pedidoventa}`, data);
      const { msg, pedidoventa } = resp.data;
      dispatch(pedidoventaAdded(pedidoventa));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const pedidoventaStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_VENTAS.pedidoventa}${data.id}/`,
        data,
      );
      const { msg, pedidoventa } = resp.data;
      dispatch(pedidoventaUpdated(pedidoventa));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const pedidoventaStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_VENTAS.pedidoventa}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(pedidoventaDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const pedidoventaLoaded = (pedidosventas) => ({
  type: types.pedidosventasLoaded,
  payload: pedidosventas,
});
const pedidoventaAdded = (pedidoventa) => ({
  type: types.pedidoventaAdded,
  payload: pedidoventa,
});
const pedidoventaUpdated = (pedidoventa) => ({
  type: types.pedidoventaUpdated,
  payload: pedidoventa,
});
const pedidoventaDeleted = (pedidoventa) => ({
  type: types.pedidoventaDeleted,
  payload: pedidoventa,
});
export const pedidoventaSetActive = (pedidoventa) => ({
  type: types.pedidoventaSetActive,
  payload: pedidoventa,
});
const pedidoventaClearActive = () => ({
  type: types.pedidoventaClearActive,
});
const detallePedidoventaSetActive = (detalle) => ({
  type: types.detallePedidoventaSetActive,
  payload: detalle,
});
const detallePedidoventaClearActive = () => ({
  type: types.detallePedidoventaClearActive,
});
export const pedidoventaStatusLoading = (loading = true) => ({
  type: types.dataLoading,
  payload: loading,
});
// Extra Async Functions

export const getMonedas = async () => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_VENTAS.pedidoventa}get_monedas/`,
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};

const getAlmacenesEmpleadoSelect = async (empleado) => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_VENTAS.pedidoventa}get_almacenes_byempledo/`,
      {
        params: { empleado },
      },
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
const get_pdf_pedidoventa = async (pedidoventa) => {
  let datos = [];
  try {
    const resp = await axiosConToken.get(
      `${PATH_VENTAS.pedidoventa}get_pdf_pedidoventa/`,
      {
        responseType: "blob",
        params: { pedidoventa },
      },
    );
    datos = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return datos;
};
const get_estadospedidoventa = async () => {
  try {
    const resp = await axiosConToken.get(
      `${PATH_VENTAS.pedidoventa}get_estadospedidoventa/`,
    );
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};
export {
  pedidoventaClearActive,
  getAlmacenesEmpleadoSelect,
  get_pdf_pedidoventa,
  detallePedidoventaSetActive,
  detallePedidoventaClearActive,
  get_estadospedidoventa,
};
